<vs-form-field
  [config]="{ label: (displayLabel || property.name) + (required ? '' : ' (optional)') + ':' }"
  appearance="vertical"
>
  <span *ngIf="helpText" slot="hint" class="text-gray-600 text-sm">{{ helpText }}</span>
  <vs-input-container>
    <vs-date-property-input
      class="w-full"
      [property]="property"
      [formControl]="formControl"
      [disabled]="disabled"
      [required]="required"
    ></vs-date-property-input>
  </vs-input-container>
  <span class="text-danger" slot="hint" *ngIf="formControl.touched && formControl.hasError('required')">
    {{ displayLabel || property.name }} is required
  </span>
  <span class="text-danger" slot="hint" *ngIf="formControl.touched && formControl.hasError('minDate')">
    {{ displayLabel || property.name }} must be on or after {{ property.config.min | date }}
  </span>
  <span class="text-danger" slot="hint" *ngIf="formControl.touched && formControl.hasError('maxDate')">
    {{ displayLabel || property.name }} must be on or before {{ maxDate | date: undefined : 'UTC' }}
  </span>
</vs-form-field>
